
import * as actionTypes from './actionType';

export const selectAPI = (apiID) => { return {type: actionTypes.SET_API, 'currentAPIID': apiID} }
